<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vx-card class="mb-2">
      <div class="vx-row mb-2 w-full">
        <div class="vx-col sm:w-8/12 ml-5">
          <vs-input
            v-model="filter"
            class="w-full"
                v-focus
            @keyup.enter="
              pageNo = 1;
              getData();
            "
          />
        </div>
        <div class="vx-col sm:w-2/12">
          <vs-button
            @click="
              pageNo = 1;
              getData();
            "
            class="mx-3"
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            >جستجو</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vx-card class="mb-2">
      <vs-table id="tbl2" ref="tbl2" :data="items" class="table-dark-inverted">
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/3 flex-inline">
              <vs-button
                style="float: left"
                @click="new_()"
                class="mx-3"
                color="dark"
                type="border"
                icon-pack="feather"
                icon="icon-plus"
                >جدید</vs-button
              >
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>ردیف</vs-th>
          <vs-th>نام</vs-th>
          <vs-th>توضیحات</vs-th>
          <vs-th>پیشفرض</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="tr.commissionGroup.id" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ indextr + 1 }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.commissionGroup.name }}</span>
            </vs-td>
            <vs-td>
              <span :title="tr.commissionGroup.description">{{
                tr.commissionGroup.description
                  ? tr.commissionGroup.description.substring(0, 50)
                  : ""
              }}</span>
            </vs-td>
            <vs-td>
              <feather-icon
                v-if="tr.commissionGroup.isDefault"
                strokeWidth="2"
                title="پیشفرض"
                icon="CheckCircleIcon"
                svgClasses="h-6 w-6 text-success"
              ></feather-icon>
              <vs-button
                class="p-0"
                v-if="!tr.commissionGroup.isDefault"
                color="primary"
                type="flat"
                @click="setAsDefault(tr.commissionGroup.id)"
                >تنظیم بعنوان پیشفرض</vs-button
              >
            </vs-td>
            <vs-td>
              <vs-button
                :to="
                  '/merchant/merchants?commissionGroup=' +
                  tr.commissionGroup.id +
                  '&name=cccc'
                "
                color="primary"
                type="flat"
                >پذیرنده ها</vs-button
              >
            </vs-td>
            <vs-td>
              <vs-button
                color="primary"
                type="flat"
                @click="
                  showCommisions(tr.commissionGroup.id, tr.commissionGroup.name)
                "
                >کارمزدها</vs-button
              >
            </vs-td>
            <vs-td>
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="
                      edit(tr.commissionGroup.id, tr.commissionGroup.name)
                    "
                    >ویرایش</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    @click="
                      confirmDelete(
                        tr.commissionGroup.id,
                        tr.commissionGroup.name
                      )
                    "
                    >حذف</vs-dropdown-item
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="getData"
      />
    </vx-card>
    <create-or-edit-commission-group
      ref="CreateOrEditCommissionGroup"
      @success="getData"
    ></create-or-edit-commission-group>
  </div>
</template>
<style>
</style>
<script>
import CreateOrEditCommissionGroup from "./CreateOrEditCommissionGroup.vue";
import Commissions from "./Commissions.vue";
export default {
  props: {},
  components: {
    CreateOrEditCommissionGroup,
    Commissions,
  },
  data() {
    return {
      items: [],
      totalCount: 1,
      pageSize: 20,
      pagesCount: 1,
      pageNo: 1,
      filter: "",
    };
  },
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filter = this.$route.query.f || this.filter;
      }
    },
    getData() {
      const query = {
        ps: this.pageSize,
        pno: this.pageNo,
      };
      if (this.filter) query.f = this.filter;
      this.$router.replace({
        query: query,
      });

      let loading = this.$vs.loading();
      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
          Filter: this.filter,
        },
      };
      this.$http
        .get("/api/services/app/CommissionGroups/GetAll", payload)
        .then((response) => {
          this.items = response.data.result.items;
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    new_(id) {
      this.$refs.CreateOrEditCommissionGroup.show();
    },
    confirmDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `تاییدیه حذف`,
        text: `آیا از حذف قالب‌کارکزد "${name}" مطمئن هستید؟`,
        accept: () => {
          this.delete_(id);
        },
        acceptText: "تایید",
        cancelText: "انصراف",
      });
    },
    delete_(id) {
      let loading = this.$vs.loading();
      let payload = {
        params: {
          id: id,
        },
      };
      this.$http
        .delete("/api/services/app/CommissionGroups/Delete", payload)
        .then((response) => {
          if (response.data.success == true) {
            this.getData();
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "قالب‌کارمزد با موفقیت حذف شد",
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    setAsDefault(id) {
      let loading = this.$vs.loading();
      let payload = {
        id: id,
      };
      this.$http
        .post(
          "/api/services/app/CommissionGroups/SetDefaultCommissionGroup",
          payload
        )
        .then((response) => {
          if (response.data.success == true) {
            this.getData();
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "قالب‌کارمزد با موفقیت بعنوان پیشفرض تنظیم شد",
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    edit(id, name) {
      this.$refs.CreateOrEditCommissionGroup.show(id, name);
    },
    showCommisions(id, name) {
      this.$router.push({
        name: "Commissions",
        params: {
          commissionGroupId: id,
          commissionGroupName: name,
        },
      });
      //this.$refs.CommissionsOfGroup.show(id, name);
    },
  },
  mounted() {
    this.initFilters();
    this.getData();
  },
};
</script>
